<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" class="event-wrapper" v-for="event in events" :key="event.id">
        <event-card :event="event" short-text></event-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
	import EventCard from './EventCard'

	export default {
    title() {
      return `Articket Tickets`
    },
		data() {
			return {
        events: [],
        header: 1,
			}
		},
		components: {
      EventCard
    },
		methods: {
		  init() {
        axios.get('/event').then((response) => {
          this.events = response.data;
        })
      },
      onResize () {
        this.header = 1;
        if (window.innerWidth <= 767) {
          this.header = 0;
        }
      },
    },
		mounted: function () {
      this.init()
      this.onResize();
		}
	}
</script>
<style lang="scss" scoped>
@media (max-width: 480px){
  .event-box h2 {
    font-size: 1.4rem;
  }
  .event-box h4 {
    font-size: 1.1rem;
  }
}

.page-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .event-wrapper {
    max-width: 800px;
  }
}

</style>
